export default {
  formatBRL(value: number): string {
    return value.toLocaleString('pt-BR', {
      currency: 'BRL',
      style: 'currency',
    });
  },
};
